import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { INavigationTree } from "@faire/web-api--source/indigofair/data/INavigationTree";
import React from "react";

import { ExpandableToFullHeight } from "@faire/retailer/components/ExpandableToFullHeight/ExpandableToFullHeight";
import { SDUIFilterablePaginatedSectionNavigationLink } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/CategoryNavigation/SDUIFilterablePaginatedSectionNavigationLink";

export const SDUIFilterablePaginatedSectionCategoryNavigationRenderer: React.FC<{
  navigationTree?: INavigationTree;
}> = ({ navigationTree }) => {
  if (navigationTree?.navigation_group?.length === 0) {
    return null;
  }

  return (
    <ExpandableToFullHeight>
      <nav
        style={{ marginBottom: getSpacing("1x") }}
        data-test-id="category-page-sidebar"
      >
        <ul>
          {navigationTree?.navigation_group?.map((navigationGroup, index) => {
            const listHeaderId = `category-list-header-${
              navigationGroup.group_title ?? "".toLowerCase().replace(" ", "-")
            }`;

            return (
              <React.Fragment key={listHeaderId}>
                {navigationGroup.group_title ? (
                  <>
                    {index > 0 ? <Spacer size="3x" /> : null}
                    <Typography variant="paragraphSansMedium" id={listHeaderId}>
                      {navigationGroup.group_title}
                    </Typography>
                    <Spacer size="1x" />
                  </>
                ) : null}
                {navigationGroup.links.map((link) => (
                  <li key={link.identifier}>
                    <SDUIFilterablePaginatedSectionNavigationLink
                      navigationTreeLink={link}
                    />
                  </li>
                ))}
              </React.Fragment>
            );
          })}
        </ul>
      </nav>
    </ExpandableToFullHeight>
  );
};
